require("../../libs/backbone/backbone.ajaxq.adapter.ts");
var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/counters_options.template.htm');
require('dhtmlxMessage');
var HandlebarsHelpers = require('../../libs/handlebars/handlebars-helpers.ts');
var Row = require('text-loader!../templates/row_counter.template.htm');
var RowAddCounter = require('text-loader!../templates/row_add_counter.template.htm');
var Model = require('models/counters.model.ts');
var Collection = require('../models/counters.paginated.collection.ts');
var i18n = require("l10n");

var TheView = GenericView.extend({
    el: '#countersOptions',
    tagName: 'div',
	template: Handlebars.compile(Template),
	row: Handlebars.compile(Row),
	rowAdd: Handlebars.compile(RowAddCounter),
	superInitialize: GenericView.prototype.initialize,
	queueId: null,
	countersCount: 0,
	removedCounters: [],
	totalCalls: 0,
	elementsArray: {},
	initialize: function (options) {
		this.queueId = options.queueId;
		this.render();
	},
	loadCounters: function()
	{
		var self = this;
		if(!this.isNewQueue())
		{

			this.collection = new Collection();
			this.collection.url = "/rest/api/counters?filter=" + encodeURIComponent("queue=" + this.queueId);
			this.collection.on( 'sync', this.fillCounters, this );
			this.collection.getFirstPage();
		}
		else
		{
			this.fillCounters();
		}
	},
	superRender: GenericView.prototype.render,
	render: function () {
		var self = this;

		this.superRender();
		this.$el.html(this.template());
		this.loadCounters();


	},
	events: {
		'click #add_new_counter': "addNewCounterRow",
		'click .remove-counter': "removeCounter",
		"input .counter-container input": "validateRowOnChange",
	},
	validateRowOnChange: function(event)
	{
		var element = $(event.currentTarget);
		this.isValid(element.data("index"));
	},
    areCountersToBeDeleted: function() {
        return this.removedCounters.length > 0;
    },
	removeCounter: function(event)
	{

		var element = $(event.currentTarget)
		var index = element.data("remove-index");
		var counter_id = $('#counterRow'+index).data("counter-id");

		$('#counterRow'+index).remove();

		delete this.elementsArray["temp"+index];

		if(counter_id)
			this.removedCounters = this.removedCounters.concat([ counter_id ]);

	},
	addNewCounterRow: function(event)
	{
		var rowParent = $(event.currentTarget).parent().parent();
		rowParent.remove();
		this.addCounterRow();
		this.addMore();
	},
	fillCounters: function()
	{
		this.$el.html("");
		if (this.isNewQueue())
		    this.addCounterRow();
		if(this.collection)
			for(var index in this.collection.models)
			{
				var obj = this.collection.models[index];
				this.addCounterRow(obj);
			}

		this.addMore();
	},
	addCounterRow: function(obj)
	{
		this.$el.append(this.row($.extend(obj, { index: this.countersCount})));
		this.elementsArray["temp"+this.countersCount] = obj;
		this.countersCount++;
	},
	addMore: function()
	{
		this.$el.append(this.rowAdd());
	},
	isNewQueue: function()
	{
		return this.queueId ? false : true;
	},
	setNewQueueId: function(queueId)
	{
		this.queueId = queueId;
	},
	isTheDataWrong: function()
	{
		var self = this;
		var has_error = false;
		var counter = $(".counter-container");
		counter.each(function()
		{
			has_error = !self.isValid($(this).data("index")) || has_error;
		});

		return has_error;
	},
	isValid: function(index)
	{
		var element = $('#counterRow' + index);
		if(element.find("input").val().trim() == "")
		{
			element.find("span.counter-error").html(i18n.t("analytics.empty_name"));
			return false;
		}
		element.find("span.counter-error").html("");
		return true;
  	},
  	updateData: function(callback)
  	{
  		var self = this;
  		this.callback = callback;

        var dataToPatch = [];
        var dataToPost = [];

		var allCounters = $(".counter-container");
		allCounters.each(function()
		{
			var counterId = $(this).data("counter-id");
			var index = $(this).data("index");
            var name =  $(this).find("input").val().trim();

			if(counterId)
			{
				var currentCounter = self.elementsArray["temp"+index];
				if(name != currentCounter.attributes.name)
				{
					dataToPatch.push({"index": index, "id": counterId, "name": name, "queueId": self.queueId});
				}

			}
			else
			{
			    dataToPost.push({"index": index, "name": name, "queueId": self.queueId});
			}

		});

        this.totalCalls = 3; //one for each of the following

		this.doDelete();
		this.doPost(dataToPost);
		this.doPatch(dataToPatch);

		if(this.totalCalls == 0)
		    this.callback.success();
  	},
  	doPost: function(dataArray) {
  	    this.totalCalls = this.totalCalls && this.totalCalls > 0 ? this.totalCalls - 1 : 0;

  	    if(dataArray === 'undefined' || dataArray.length <= 0)
  	        return;

  		var self = this;
		data = {queueId: this.queueId, name: name};

		this.showActionProgressBar();

		$.ajaxDefaultQ({
			url: '/rest/api/counters/many',
			type: 'POST',
			contentType: "application/json;charset=UTF-8",
			data: JSON.stringify(dataArray),
		}).done(function(response, status, xhr){
            if(self.totalCalls == 0 && self.callback && self.callback.success)
                self.callback.success();

			self.canITriggerListener();
			self.hideActionProgressBar();

		})
		.fail(function(response) {
		    if(self.totalCalls == 0 && self.callback && self.callback.success)
                self.callback.success(response);
			self.canITriggerListener();
			self.hideActionProgressBar();
		});
  	},
  	doDelete: function() {
		var self = this;

		this.totalCalls = this.totalCalls && this.totalCalls > 0 ? this.totalCalls - 1 : 0;

        if( this.removedCounters.length == 0) {
            if(this.totalCalls == 0 && this.callback && this.callback.success)
                this.callback.success(true);
            return;
        }

		url = '/rest/api/counters?';
		var params = "";
		for (var i = 0; i < this.removedCounters.length; i++) {

		  if(params != "")
				params = params + ",";

		  params = params + this.removedCounters[i];
		}

		url = url +"ids=" + encodeURIComponent(params);
		this.removedCounters = [];

		this.showActionProgressBar();

		$.ajaxDefaultQ({
			url: url,
			type: 'DELETE',
			contentType: "application/json;charset=UTF-8",
		}).done(function(response, status, xhr){
            if(self.totalCalls == 0 && self.callback && self.callback.success)
                self.callback.success(response);
			self.canITriggerListener(response);
			self.hideActionProgressBar();

		})
		.fail(function(response) {
		    if(self.totalCalls == 0 && self.callback && self.callback.success)
                self.callback.success(response);
			self.canITriggerListener(response);
			self.hideActionProgressBar();
		});

	},
	doPatch: function(dataArray) {
		var self = this;

        this.totalCalls = this.totalCalls && this.totalCalls > 0 ? this.totalCalls - 1 : 0;

        if(dataArray === 'undefined' || dataArray.length <= 0)
            return;

		this.showActionProgressBar();
		$.ajaxDefaultQ({
			url: "/rest/api/counters/many",
			type: 'PATCH',
			contentType: "application/json;charset=UTF-8",
			data: JSON.stringify(dataArray),
		}).done(function(response, status, xhr){
            if(self.totalCalls == 0 && self.callback && self.callback.success)
                self.callback.success(response);

			for(i=0; i<dataArray.length; i++) {
			    self.elementsArray["temp"+ dataArray[i].index ] = {
			        attributes: $.grep(response.data, function(val, indx) {
			            return val.id = dataArray[i].id;
			        })
			    }
			}

			self.canITriggerListener(response);
			self.hideActionProgressBar();

		})
		.fail(function(response) {
            if(self.totalCalls == 0 && self.callback && self.callback.success)
                self.callback.success(response);
			self.canITriggerListener(response);
			self.hideActionProgressBar();
		});

	},
	canITriggerListener: function(response)
	{
		var self = this;

		self.totalCalls = self.totalCalls - 1;
		//if(self.callback && self.callback.success)
		    //self.callback.success(response);
	},
	clearView: function()
    {
        this.$el.html("");
        this.countersCount = 0;
    }



});

module.exports = TheView;